import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/',
    name: 'Home',
    redirect: '/dashboard',
    component: () => import('../views/Home.vue'),
    children: [
      { path: 'dashboard', name: 'Dashboard', component: () => import('../views/Dashboard.vue'), meta: { page: 'dashboard' } },
      { path: 'vehicle', name: 'Vehicle', component: () => import('../views/Vehicle.vue'), meta: { page: 'vehicle' } },
      { path: 'vehicle-model', name: 'VehicleModel', component: () => import('../views/VehicleModel.vue'), meta: { page: 'vehicle' } },
      { path: 'manager', name: 'Manager', component: () => import('../views/Manager.vue'), meta: { page: 'vehicle' } },
      { path: 'customer', name: 'Customer', component: () => import('../views/Customer.vue'), meta: { page: 'customer' } },
      { path: 'customer-verify', name: 'CustomerVerify', component: () => import('../views/CustomerVerify.vue'), meta: { page: 'customer' } },
      { path: 'rental-apply', name: 'RentalApply', component: () => import('../views/RentalApply.vue'), meta: { page: 'rental-apply' } },
      { path: 'order', name: 'Order', component: () => import('../views/Order.vue'), meta: { page: 'order' } },
      { path: 'repair', name: 'Repair', component: () => import('../views/Repair.vue'), meta: { page: 'repair' } },
      { path: 'finance', name: 'Finance', component: () => import('../views/Finance.vue'), meta: { page: 'finance' } },
      { path: 'permission', name: 'Permission', component: () => import('../views/Permission.vue'), meta: { page: 'permission' } },
      { path: 'banner', name: 'Banner', component: () => import('../views/Banner.vue'), meta: { page: 'banner' } }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  if (to.path === '/login') {
    next()
  } else if (!token) {
    next('/login')
  } else {
    next()
  }
})

export default router